import React from 'react'
import { gantt } from 'dhtmlx-gantt'
import $ from 'jquery'
import "jquery-ui-dist/jquery-ui"
/* import dhtmlXMenuObject from '../../../dxhtmlgantt/codebase/dhtmlxgantt' */
/* import 'dhtmlx-gantt/codebase/skins/dhtmlxgantt_skyblue.css' */
import 'dhtmlx-gantt/codebase/skins/dhtmlxgantt_new_material.css'
import { useEffect , useRef, useState } from 'react'
import ReactDOM from "react-dom";
import axios from "axios"
import { API_ROUTE, headersRequest, getResourceNames , calcularDuracionV2 } from '../../helpers'
import moment from 'moment'
import { Button, Col, Container, Row } from 'react-bootstrap';


const GanttDx = (props) => {
    
    const excludedDates = useRef([]);
    const companyResources = useRef([]);
    const setLightBoxSections = () => {
      gantt.config.lightbox.sections=[
        {name:"description", label: "Actividad", height:70, map_to:"text", type:"textarea", focus:true},
        {name:"time",  height:35, map_to:"auto", type:"datepicker"},
        { name:"type",height:50, map_to:"type",type:"typeselect", options: [ 
          {key:"project", label: "Fase"},
          {key:"task", label: "Tarea"},                                               
          {key:"milestone", label: "Hito"}]},
        {name:"progress", height:50, map_to:"progress",type:"progress_number"},
        {name:"owner",  height:150, map_to:"owner_id", type:"resources",  options: gantt.serverList("resourceList") },
       
      
      ];
      gantt.locale.labels.section_type = "Tipo";
      gantt.locale.labels.section_description = "Actividad";
      gantt.locale.labels.section_owner = "Recursos";
      gantt.locale.labels.section_time = "Fecha";
      gantt.locale.labels["section_progress"] = "% Progreso"     
      gantt.render();
    }    
    const setCalender = (data)=> {
        let excluded = [];
        let formatDate = gantt.date.str_to_date("%Y/%m/%d");     
            for (let i = 0; i < data.length; i++) {
                let datex = formatDate(data[i]);
                excluded.push(datex);
                gantt.setWorkTime({
                date: datex,
                hours: false
                });
            }
        gantt.serverList("excluded", excluded);
        gantt.render();
    }
    const setResour = (data) => {
      
      let resoList = data?.map((resource)=>{
       return {key: resource.id, label: resource.text}
      }) 
     gantt.serverList("resourceList",resoList)
     setLightBoxSections() 
     /* sectionForMilestonesProjects()
     sectionForProjects() */
   }

    const setTask = (data) => {
       
        let task = [];
        for(let row of data)
        {
        let res = [];
        if(row.recursos != null)
        {
            let resarr = row.recursos.split(',');
            for(let itm of resarr)
            {
            if(itm.length > 0)
            {
                res.push({resource_id:itm, value:8});
            }
            }
        }
            task.push({ id: row.id, text: row.title, start_date:row.start, end_date:row.end, progress: row.progress, parent: row.parentId, plancost: row.cost, realcost: row.actualCost, type: row.tipo, readonly: row.id === props.uid? true : false, open:true, owner_id: res  });
            
        }
        let alltask = { data: task};
        gantt.parse(alltask);
        gantt.render();  
    }

    const setDependen = (data) => {
       
        let links = [];
        for(let lnk of data)
        {
        gantt.addLink({id: lnk.id, type: "0", source: lnk.predecessorId, target: lnk.successorId });
        }
        gantt.render();
    }

    const configColumns = () => {
        let textEditor = { type: "text", map_to: "text" };
        let dateEditor = { type: "date", map_to: "start_date", min: new Date(2018, 0, 1), max: new Date(2019, 0, 1) };
        let durationEditor = { type: "number", map_to: "duration", min: 0, max: 100 };

        var getInput = function(node){
          return node.querySelector("input");
      };
        
        gantt.config.editor_types.AllCost = {
          show : (id,column,config, placeholder) =>{
           
            let typeOfTask = gantt.getTaskType(gantt.getTask(id))
            let min = config.min || 0,
            max = config.max || 100;
 
            var html = "<div><input class='bg-light' disabled type='number' min='" + min + 
                          "' max='" + max + "' name='" + column.name + "'></div>";
            
            var html2 = "<div><input  type='number' min='" + min + 
            "' max='" + max + "' name='" + column.name + "'></div>";

            placeholder.innerHTML = (typeOfTask == "project")? html : html2;
          },
          hide : ()=>{

          },
          set_value: function (value, id, column, node) {
            getInput(node).value = value;
          },
          get_value: function (id, column, node) {
              return getInput(node).value || 0;
          },
          is_changed: function (value, id, column, node) {
              var currentValue = this.get_value(id, column, node);
              return Number(value) !== Number(currentValue);
          },
          is_valid: function (value, id, column, node) {
              return !isNaN(parseInt(value, 10));
          },
          focus: function (node) {
              var input = getInput(node);
              if (!input) {
                  return;
              }
              if (input.focus) {
                  input.focus();
              }
      
              if (input.select) {
                input.select();
              }
          }

        }
        let planEditor = { type: "AllCost", map_to: "plancost", min: 0, max: 9999999999 };
        let realEditor = { type: "AllCost", map_to: "realcost", min: 0, max: 9999999999 };

        gantt.config.columns = [
        { name: "add", align: "center" },
        { name: "wbs", label: "Wbs", width: "40", template: gantt.getWBSCode, resize: true },
        { name: "text", label: "Actividad", tree: true, min_width: 250, width: "*",resize: true },
        { name: "type", label: "Tipo", resize: false, hide: true },
        { name: "start_date", label: "Inicio", align: "center", min_width: 100, resize: true , template : (item)=>{
          
          let dateWithFormat = new Intl.DateTimeFormat('es-CL').format(item.start_date)
          return dateWithFormat
        } },
        { name: "end_date", label: "Fin", align: "center", min_width: 100, resize: true, template : (item)=>{
          
          let dateWithFormat = new Intl.DateTimeFormat('es-CL').format(item.end_date)
          return dateWithFormat
        }  },
        { name: "duration", label: "Duración", align: "center", resize: true, editor: durationEditor },
        { name: "plancost", label: "Costo", align: "center", resize: true, editor: planEditor},
        { name: "realcost", label: "Costo Real", align: "center", resize: true, editor: realEditor },
        { name: "predecessor", label: "Predecesora", align: "center", resize: true,
         template: function (item) {
            let formatter = gantt.ext.formatters.durationFormatter({
                enter: "day",
                store: "hour",
                format: "day",
                hoursPerDay: 24,
                hoursPerWeek: 40,
                daysPerMonth: 30,
                short: true
            });
            let linksFormatter = gantt.ext.formatters.linkFormatter({ durationFormatter: formatter });
            
            let links = item.$target;
            let labels = [];
            for (let i = 0; i < links.length; i++) {
                let link = gantt.getLink(links[i]);
                if (!labels.find(x => { return x == linksFormatter.format(link); }))
                labels.push(linksFormatter.format(link));
            }
            let predecessors = labels.join(", ");
            
            return predecessors;
            }
        },
        {
          name: "progress", label: "Progreso", width: 80, align: "center",
          template: function (item) {
            if (item.progress >= 1)
              return "Completada";
            if (item.progress == 0)
              return "Por Iniciar";
            return Math.round(item.progress * 100) + "%";
          }
        },
        // {
        //   name: "owner_id", label: "Recursos", width: "*", min_width: 300, align: "left", template: function (item) {
        //     return GetResourceNames(gantt.serverList("resourceList"), item.owner_id);
        //   }
        // },
        ];

        gantt.templates.rightside_text = function(start, end, task){
            return getResourceNames(gantt.serverList('resourceList'), task.owner_id);
        };
        // Permitir mover las tareas
        gantt.config.order_branch = "marker";
       /*  gantt.config.drag_progress = false; */
    }


    
     const zoomConfig = {
        levels: [
          {
            name:"day",
            scale_height: 27,
            min_column_width:80,
            scales:[
              {unit: "day", step: 1, format: "%d"}
            ]
          },
          {
            name:"week",
            scale_height: 50,
            min_column_width:50,
            scales:[
              {unit: "week", step: 1, format: function (date) {
                var dateToStr = gantt.date.date_to_str("%d %M");
                var endDate = gantt.date.add(date, -6, "day");
                var weekNum = gantt.date.date_to_str("%W")(date);
                return "#" + weekNum + ", " + dateToStr(date) + " - " + dateToStr(endDate);
              }},
              {unit: "day", step: 1, format: "%j"}
            ]
          },
          {
            name:"month",
            scale_height: 50,
            min_column_width:120,
            scales:[
              {unit: "month", format: "%F, %Y"},
              {unit: "week", format: "Week #%W"}
            ]
          },
          {
            name:"quarter",
            height: 50,
            min_column_width:90,
            scales:[
              {unit: "month", step: 1, format: "%M"},
              {
                unit: "quarter", step: 1, format: function (date) {
                  var dateToStr = gantt.date.date_to_str("%M");
                  var endDate = gantt.date.add(gantt.date.add(date, 3, "month"), -1, "day");
                  return dateToStr(date) + " - " + dateToStr(endDate);
                }
              }
            ]
          },
          {
            name:"year",
            scale_height: 50,
            min_column_width: 30,
            scales:[
              {unit: "year", step: 1, format: "%Y"}
            ]
          }
        ]
    };  

    const getGanttData = () => {
        let getTasks = new Promise((resolve, rej) => {
          axios
            .get(`${API_ROUTE}v2/schedule-tasks/${props.uid}`, headersRequest())
          
            .then((res) => {
              let processed = res.data.tasks.map((task) => {
            
                return {
                  ...task,
                  start: new Date(task.start),
                  end: new Date(task.end),
                  parentId: !task.parentId ? 0 : task.parentId,
                  cost: task.cost ? task.cost : 0,
                 /*  Hito: task.Hito, */
                };
              });
              console.log("Tasks:");
              setTask(processed)
              setDependen(res.data.links)
              
              resolve(processed);
            });
        });
        let getDependencies = new Promise((resolve, rej) => {
          axios
            .get(
              `${API_ROUTE}schedule-tasks-dependencies/${props.uid}`,
              headersRequest()
            )
            .then((res) => {
              console.log("Dependences:");
               /* setDependen(res.data)  */
              resolve(res.data);
            });
        });
        let getAssignments = new Promise((resolve, rej) => {
          axios
            .get(
              `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}`,
              headersRequest()
            )
            .then((res) => {
              resolve(res.data);
            });
        });
        let getExcludedDates = new Promise((resolve, rej) => {
          axios.get(`${API_ROUTE}excluded-dates`, headersRequest()).then((res) => {
           
            setCalender(res.data)
            resolve(res.data);
          });
        });
        let getResources = new Promise((resolve, rej) => {
          axios
            .get(`${API_ROUTE}company-resources`, headersRequest())
            .then((res) => {
                /* console.log(res.data) */
                setResour(res.data)
              resolve(res.data);
            });
        });
        
        Promise.all([
          getTasks,
          getDependencies,
          getAssignments,
          getExcludedDates,
          getResources
        ]).then((values) => {
          excludedDates.current = values[3];
          companyResources.current = values[4];
          ReactDOM.unstable_batchedUpdates(() => {
            console.log("respuestas")
            /* setTasks(values[0]); */
            
          });
        });
      };

    
    gantt.config.layout = {
        css: "gantt_container",
        cols: [
        {
          width:600,
          min_width: 300,
      
          
          rows:[
            {view: "grid", scrollX: "gridScroll", scrollable: true, scrollY: "scrollVer"}, 
            {view: "scrollbar", id: "gridScroll",group:"horizontal"}  
          ]
        },
        {resizer: true, width: 1},
        {
          rows:[
            {view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer"},
            {view: "scrollbar", id: "scrollHor",group:"horizontal"}
          ]
        },
        {view: "scrollbar", id: "scrollVer"}
        ]
    };
    gantt.config.bar_height = 25;
    gantt.config.work_time = true //permite calcular la duracion de la tare en tiempo de trabajo
    gantt.config.show_progress = true // permite mostrar el progreso en la barra de tarea
    gantt.config.resource_property = "owner_ id" // propiedad de un objeto de tarea que almacena el id de recurso
    gantt.config.order_branch_free = false; // permite mover la actrividad dentro de todo el gantt
    /* gantt.config.order_branch = "marker" */ //permite reordenar las actividades dentro delmismo armor
    gantt.config.drag_progress= true //la barra de progreso. permite modifarla
    gantt.templates.timeline_cell_class = function (task, date) {
        if (!gantt.isWorkTime(date))
          return "week_end";
        return "";
      };

/* 
    useEffect(()=>{
        configColumns()
        setLightBoxSections()
        sectionForMilestonesProjects()
        sectionForProjects()
        gantt.ext.zoom.init(zoomConfig);
        gantt.ext.zoom.setLevel("quarter");  
        gantt.i18n.setLocale("es");
        
        gantt.serverList("projectId", [props.uid]); 
    },[]) */
        
/*    console.log(gantt.serverList("projectId")) */
 /*    
  useEffect(() => {
    gantt.clearAll(); // remueve las tareas antiguas
   
    
    getGanttData()
    setLightBoxSections()
    sectionForMilestonesProjects()
    sectionForProjects()

    
    // use critical path 
    gantt.plugins({
        critical_path: true, // version pro
        multiselect: true,
        auto_scheduling: true,
        drag_timeline : true,
        fullscreen : true,
        quick_info: false,
        undo: true,
        tooltip: true,
        marker: true,
        keyboard_navigation: true,
        export_api : true
    });
     //botones externos //

    gantt.init("gantt-dxhtml") 
    
    //primera fnc
    
     
  }, []) */


  

  const updateCriticalPath = (e) =>{
    e.target.enabled = !e.target.enabled;
  if (e.target.enabled) {
    e.target.innerHTML = "Ocultar ruta crítica";
    gantt.config.highlight_critical_path = true;
  } else {
    e.target.innerHTML = "Mostrar ruta crítica" ;
    gantt.config.highlight_critical_path = false;
  }
  gantt.render();
  }

  const zoomIn = ()=>{
    gantt.ext.zoom.zoomIn();
  }

  const zoomOut = ()=>{
    gantt.ext.zoom.zoomOut()
  }

  // botones externos
    
    // set types of tasks //
   /*  gantt.config.types = {
      task :"task",
      project :"phase",
      milestone :"milestone"
    } 
    gantt.config.types.project = "phase"
    
    */
    /* console.log(gantt.config.types) */
    /* gantt.config.types["customType"]="type_id" */
    /* gantt.locale.labels['type_'+"project"]="Fase" */
    /* console.log(gantt.config.types) */
    //se puede crear otra opciones para q tengamos tarea,fase,hito, proyecto
    // set types of tasks //

    //motrar tooltip
   /*  gantt.attachEvent("onGanttReady",()=>{
      let tooltips = gantt.ext.tooltips;
      tooltips.tooltip.setViewport(gantt.$task_data)
    }) */

    //motrar fecha de corte
   /*  let dateToStr = gantt.date.date_to_str(gantt.config.task_date)
      let today_marker = new Date() */
    
    /* useEffect(()=>{
      gantt.addMarker({
        start_date : today_marker,
        css : "status_line",
        text:"Hoy",
        title: `Fecha : ${dateToStr(today_marker)}`
      });
    },[]) */

    // seleccion de columnas a mostrar //

    //full screen //
    gantt.attachEvent("onTemplatesReady", function () {
      var toggle = document.createElement("i");
      toggle.className = "fa fa-expand gantt-fullscreen";
      gantt.toggleIcon = toggle;
      gantt.$container.appendChild(toggle);
      toggle.onclick = function() {
        gantt.ext.fullscreen.toggle();
      };
    });
    gantt.attachEvent("onExpand", function () {
      var icon = gantt.toggleIcon;
      if (icon) {
        icon.className = icon.className.replace("fa-expand", "fa-compress");
      }
  
    });
    gantt.attachEvent("onCollapse", function () {
      var icon = gantt.toggleIcon;
      if (icon) {
        icon.className = icon.className.replace("fa-compress", "fa-expand");
      }
    });
  
    //auto scheduling permite actualizar la fecha de una tarea si una anterioa a ella se movio//

    gantt.config.auto_scheduling = false;
    gantt.config.auto_scheduling_strict = false;
    gantt.config.auto_scheduling_compatibility = false;

    // btn regresar y adelante  //
    const btnUndo = ()=>{
      gantt.undo()
    }
    const btnRedo = () =>{
      gantt.redo()
    }

    //btn expand and colapse //

    const expandAllTask = () => {
      gantt.batchUpdate(function () {
        gantt.eachTask(function (task) {
            gantt.open(task.id)
        })
    })
    }

    const collapseAllTask = () => {
      gantt.batchUpdate(function () {
        gantt.eachTask(function (task) {
            gantt.close(task.id)
        })
    })
    }
  // mostrar todas las tareas que pertenecen que tienen un vinculo //
  (function() {
		var highlightTasks = [],
			highlightSearch = {};

		function reset(value) {
			if (value) {
				if (value.join() === highlightTasks.join()) {
				    return;
				}
				highlightTasks = value;
				highlightSearch = {};
				highlightTasks.forEach(function(id){
					highlightSearch[id] = true;
				});
				gantt.render();
			}
			else if (highlightTasks.length) {
				highlightTasks = [];
				highlightSearch = {};
				gantt.render();
			}
		}

		gantt.templates.task_class = function(start, end, task) {
			if (highlightSearch[task.id])
				return "task_groups";
			return "";
		};

		gantt.attachEvent("onTaskClick", function(id) {
			var task = gantt.getTask(id);
			var group = gantt.getConnectedGroup(id);
			if(!group.tasks.length){
				reset();
			}else{
				reset(group.tasks);
			}

			return true;
		});

		gantt.attachEvent("onEmptyClick", function() {
			reset();
			return true;
		});

	})();

  // mostrar colores en las filas y columna de progreso //
  gantt.templates.grid_row_class = function (start_date, end_date, item) {
		if (item.progress == 0) return "red";
		if (item.progress >= 1) return "green";
	};
	gantt.templates.task_row_class = function (start_date, end_date, item) {
		if (item.progress == 0) return "red";
		if (item.progress >= 1) return "green";
	};
    
  //mostrar btns al hacer zoom //
 
  /* useEffect(()=>{
    gantt.ext.fullscreen.getFullscreenElement = ()=>{
      return document.getElementById("show-btns-gantt")
    }
  },[]) */
  
  // mostrar progreso en la barra //
  /* gantt.templates.progress_text = function (start, end, task) {
		return "<span style='text-align:left;'>" + Math.round(task.progress * 100) + "% </span>";
	}; */

  /* Ajuste de tamaño automatico */
  /* gantt.config.date_format = "%Y-%m-%d %H:%i:%s"; */
  gantt.config.autosize = true
  /* tarea con subtareas es automaticamente una fase */
  gantt.config.auto_types = false

  // progreso en fases //
 /*  useEffect(()=>{
    (function dynamicProgress() {

      function calculateSummaryProgress(task) {
        if (task.type != gantt.config.types.project)
          return task.progress;
        var totalToDo = 0;
        var totalDone = 0;
        gantt.eachTask(function (child) {
          if (child.type != gantt.config.types.project) {
            totalToDo += child.duration;
            totalDone += (child.progress || 0) * child.duration;
          }
        }, task.id);
        if (!totalToDo) return 0;
        else return totalDone / totalToDo;
      }

      function refreshSummaryProgress(id, submit) {
        if (!gantt.isTaskExists(id))
          return;

        var task = gantt.getTask(id);
        var newProgress = calculateSummaryProgress(task);
        
        if (newProgress !== task.progress) {
          task.progress = newProgress;

          if (!submit) {
            gantt.refreshTask(id);
          } else {
            gantt.updateTask(id);
          }
        }

        if (!submit && gantt.getParent(id) !== gantt.config.root_id) {
          refreshSummaryProgress(gantt.getParent(id), submit);
        }
      }


      gantt.attachEvent("onParse", function () {
        gantt.eachTask(function (task) {
          task.progress = calculateSummaryProgress(task);
        });
      });

      gantt.attachEvent("onAfterTaskUpdate", function (id) {
        refreshSummaryProgress(gantt.getParent(id), true);
      });

      gantt.attachEvent("onTaskDrag", function (id) {
        refreshSummaryProgress(gantt.getParent(id), false);
      });
      gantt.attachEvent("onAfterTaskAdd", function (id) {
        refreshSummaryProgress(gantt.getParent(id), true);
      });


      (function () {
        var idParentBeforeDeleteTask = 0;
        gantt.attachEvent("onBeforeTaskDelete", function (id) {
          idParentBeforeDeleteTask = gantt.getParent(id);
        });
        gantt.attachEvent("onAfterTaskDelete", function () {
          refreshSummaryProgress(idParentBeforeDeleteTask, true);
        });
      })();
	  })();
  },[]) */
 

  
    gantt.templates.task_class = function (start, end, task) {
      if (task.type == gantt.config.types.project)
        return "hide_project_progress_drag";
    };

/* calculo de costo */
/* useEffect(()=>{
(function  dynamicPlanCost() {
  function calculateSymmaryPlanCost(task) {

    if (task.type != gantt.config.types.project)
      return task.plancost;
    // var totalToDo = 0; 
    var totalPlanCostDone = 0;
    gantt.eachTask(function (child) {
      if (child.type != gantt.config.types.project) {
        // totalToDo += child.duration; 
        //totalDone += (child.progress || 0) * child.duration;
        var converToNumber = parseFloat(child.plancost)
        totalPlanCostDone += converToNumber ;
        console.log(totalPlanCostDone)
      }
    }, task.id);

   
    if (!totalPlanCostDone) return 0;
    else return totalPlanCostDone ;
  }
  function refreshSummaryPlanCost(id, submit) {
  
    if (!gantt.isTaskExists(id))
      return;

    var task = gantt.getTask(id);
  
    var newPlanCost = calculateSymmaryPlanCost(task);
   
    
    if (newPlanCost != task.plancost) {
      task.plancost = newPlanCost;
   
      if (!submit) {
        gantt.refreshTask(id);
      } else {
        gantt.updateTask(id);
      }
    }

    if (!submit && gantt.getParent(id) !== gantt.config.root_id) {
      refreshSummaryPlanCost(gantt.getParent(id), submit);
    }
  }
  gantt.attachEvent("onParse", function () {
    gantt.eachTask(function (task) {
      task.plancost = calculateSymmaryPlanCost(task);
    });
  });

  gantt.attachEvent("onAfterTaskUpdate", function (id) {
    console.log("me actualizo")
    refreshSummaryPlanCost(gantt.getParent(id), true);
  });

  gantt.attachEvent("onAfterTaskAdd", function (id) {
    refreshSummaryPlanCost(gantt.getParent(id), true);
  });
  
  (function () {
    var idParentBeforeDeleteTask = 0;
    gantt.attachEvent("onBeforeTaskDelete", function (id) {
      idParentBeforeDeleteTask = gantt.getParent(id);
    });
    gantt.attachEvent("onAfterTaskDelete", function () {
      refreshSummaryPlanCost(idParentBeforeDeleteTask, true);
    });
  })();


 
})();
},[]) */

/* calculo de costo real */
/* useEffect(()=>{
  (function  dynamicRealCost() {
    function calculateSymmaryRealCost(task) {
  
     
      if (task.type != gantt.config.types.project)
        return task.realcost;
      // var totalToDo = 0; 
      var totalRealCostDone = 0;
      gantt.eachTask(function (child) {
        if (child.type != gantt.config.types.project) {
          //totalToDo += child.duration; 
          //totalDone += (child.progress || 0) * child.duration;
          var converToNumber = parseFloat(child.realcost)
          totalRealCostDone += converToNumber ;
          console.log(totalRealCostDone)
        }
      }, task.id);
  
     
      if (!totalRealCostDone) return 0;
      else return totalRealCostDone ;
    }
    function refreshSummaryRealCost(id, submit) {
    
      if (!gantt.isTaskExists(id))
        return;
  
      var task = gantt.getTask(id);
 
      var newRealCost = calculateSymmaryRealCost(task);
    
      
      if (newRealCost != task.realcost) {
        task.realcost = newRealCost;
  
        if (!submit) {
          gantt.refreshTask(id);
        } else {
          gantt.updateTask(id);
        }
      }
  
      if (!submit && gantt.getParent(id) !== gantt.config.root_id) {
        refreshSummaryRealCost(gantt.getParent(id), submit);
      }
    }
    gantt.attachEvent("onParse", function () {
      gantt.eachTask(function (task) {
        task.realcost = calculateSymmaryRealCost(task);
      });
    });
  
    gantt.attachEvent("onAfterTaskUpdate", function (id) {
      console.log("me actualizo")
      refreshSummaryRealCost(gantt.getParent(id), true);
    });
  
    gantt.attachEvent("onAfterTaskAdd", function (id) {
      refreshSummaryRealCost(gantt.getParent(id), true);
    });
    
    (function () {
      var idParentBeforeDeleteTask = 0;
      gantt.attachEvent("onBeforeTaskDelete", function (id) {
        idParentBeforeDeleteTask = gantt.getParent(id);
      });
      gantt.attachEvent("onAfterTaskDelete", function () {
        refreshSummaryRealCost(idParentBeforeDeleteTask, true);
      });
    })();
  
  
   
  })();
  },[]) */

  /* Progreso manual  my_editor / editor_descripcion*/

/* gantt.form_blocks["progress_number"] = {
  render: function (sns) {
    return "<div class='gantt_wrap_section' style='height:60px;'>"+
      "<input style='width:50px; margin-left:10px;' class='progress_number_c' type='number' min='0' max='100'>"+
      "</div>";
  },
  set_value: function (node, value, task) {
   
    let decimalValue = Math.round ( value * 100 )
    node.querySelector(".progress_number_c").value =  decimalValue || 0 ;
   // node.querySelector(".progress_number_c").value = Math.round( value * 100 ) || 0 ; 
   //node.querySelector(".editor_holders").value = task.users || ""; 
   //Math.round(task.progress*100) 
   

  },
  get_value: function (node, task) {
    // console.log(node.querySelector(".progress_number_c").value) 
    // task.users = node.querySelector(".editor_holders").value;
    //return node.querySelector(".editor_description").value; 
    return node.querySelector(".progress_number_c").value / 100;
  },
  focus: function (node) {
    var a = node.querySelector(".progress_number_c");
    a.select();
    a.focus();
  }
}; */

/* datepciker */

  
/* lightBox para hitos y proyectos */

/* const sectionForMilestonesProjects = ()=> {
  gantt.config.lightbox["milestone" + "_sections"] = [
  {name:"description", label: "Actividad", height:50, map_to:"text", type:"textarea", focus:true},
  {name:"time",  height:35, map_to:"auto", type:"duration", single_date:true, 
  },
  

  { name:"type",height:50, map_to:"type",type:"typeselect", options: [ 
    {key:"project", label: "Fase"},
    {key:"task", label: "Tarea"},                                               
    {key:"milestone", label: "Hito"}]},
    {
      name: "progress", height: 50, map_to: "progress", type: "select", options: [
        {key: "0", label: "Sin Iniciar"},
        {key: "0.1", label: "10%"},
        {key: "0.2", label: "20%"},
        {key: "0.3", label: "30%"},
        {key: "0.4", label: "40%"},
        {key: "0.5", label: "50%"},
        {key: "0.6", label: "60%"},
        {key: "0.7", label: "70%"},
        {key: "0.8", label: "80%"},
        {key: "0.9", label: "90%"},
        {key: "1", label: "Completa"}
      ]
    },
    
    {name:"owner",  height:150, map_to:"owner_id", type:"resources",  options: gantt.serverList("resourceList") },
       
       
  ];
 
} */

/* const sectionForProjects = () =>{
  gantt.config.lightbox["project" + "_sections"] = [
    {name:"description", label: "Actividad", height:50, map_to:"text", type:"textarea", focus:true},
    {name:"time",  height:35, map_to:"auto", type:"duration", readonly: true},
   //{name:"time", height:35, map_to:"auto", type:"datepicker"},
    { name:"type",height:50, map_to:"type",type:"typeselect", options: [ 
      {key:"project", label: "Fase"},
      {key:"task", label: "Tarea"},                                               
      {key:"milestone", label: "Hito"}]},
  ];
} */

/* bloquear input cost y real cost en fases */

/* gantt.attachEvent("onTaskDbClick",(id,e)=>{
  console.log(id)
  console.log(e)
  return true
}) */

/*Codigo datepicker */
/* (function () {
  function startDatepicker(node){
      return $(node).find("input[name='start']");
  }
  function endDateInput(node){
      return $(node).find("input[name='end']");
  }

  gantt.form_blocks["datepicker"] = {
      render: function (sns) { //sns - the section's configuration object
          return "<div class='gantt_cal_ltext'>"+
              "<input type='text' name='start'>"+
              "<input style='margin-left:10px' type='text' name='end'>"+
              "</div>";;
      },
      set_value: function (node, value, task, section) {
          //node - an html object related to the html defined above
          //value - a value defined by the map_to property
          //task - the task object
          //section- the section's configuration object
          let daysOfWeek = ["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"]
          let daysOfWeekMin = ["Do","Lu","Ma","Mi","Ju","Vi","Sa"]

          startDatepicker(node).datepicker({
              dateFormat: "dd-mm-yy",
              autosize: true,
              changeYear: true,
              gotoCurrent: true,
              onSelect: function (dateStr) {
                  var endValue = endDateInput(node).datepicker('getDate');
                  var startValue = startDatepicker(node).datepicker('getDate');

                  if(startValue && endValue){
                      if(endValue.valueOf() <= startValue.valueOf()){
                          endDateInput(node).datepicker("setDate", 
                              gantt.calculateEndDate({
                                  start_date: startValue, duration: 1, task:task
                              })
                          );
                      }
                  }
              },

              dayNamesMin : daysOfWeekMin 
          });

          startDatepicker(node).datepicker("setDate", task.start_date);
          

          endDateInput(node).datepicker({
              dateFormat: "dd-mm-yy",
              autosize: true,
              changeYear: true,
              gotoCurrent: true,
              onSelect: function (dateStr) {
                  
              },
              dayNamesMin : daysOfWeekMin 
          });
          endDateInput(node).datepicker("setDate", task.end_date);
         
      },
      get_value: function (node, task, section) {

       

          if(task.start_date && task.end_date) {
              var start = startDatepicker(node).datepicker('getDate');
              var end =  endDateInput(node).datepicker('getDate');

              if(end.valueOf() <= start.valueOf()){
                  end = gantt.calculateEndDate({
                      start_date: start, duration: 1, task:task
                  });
              }
              task.start_date = start;
              task.end_date = end;                 
          }

          task.duration = gantt.calculateDuration(task);
      },
      focus: function (node) {

      }
  }
})(); */

/*reordenar columnas */
gantt.config.reorder_grid_columns =true

/*habilitar navegacion con teclado */
gantt.config.keyboard_navigation_cells = true;




useEffect(()=>{
 
  $( "#datepicker" ).datepicker();
},[])

/*tareas */
useEffect(()=>{
  gantt.init("gantt-dxhtml") 
  gantt.serverList("projectId", [props.uid])
console.log("se monta el componente")
},[])
/* let dp = gantt.createDataProcessor(function (entity, action, data, id) {
  console.log(data)
  console.log(entity)
  console.log(action)
  if (entity === "task") {
    let start = moment(data.start_date, "DD-MM-YYYY HH:mm");
    let end = moment(data.end_date, "DD-MM-YYYY HH:mm");
    if (start > end) {
      return;
    }
    
    data.projectUID = gantt.serverList("projectId")[0];
    data.key = data.id;
    data.parentId = data.parent;
    data.start = start.format();
    data.end = end.format();
    data.start_date = start.format();
    data.end_date = end.format();
  switch (action) {
     
    case "create":
        console.log("creado")
        axios
          .post(
            `${API_ROUTE}v2/schedule-tasks`,
            data,
            headersRequest()
          )
          .then(function (response) {
            console.log("se creo")
            gantt.changeTaskId(data.id, response.data.TaskUID);
            gantt.refreshData()
            
        
          })
          .catch((err) => {
            alert("error al crear la actividad, por favor refrescar la página");
          });
        break;
      case "update":
       
        if (data.start_date > data.end_date) {
          return;
        }
       
        if(data.target === undefined)
        {
          axios
            .put(
              `${API_ROUTE}v2/schedule-tasks/${data.id}`,
              data,
              headersRequest()
            )
            .then(() => {
              gantt.refreshData();
             
              })
            .catch((err) => {
              alert("error al actualizar la actividad, por favor refrescar la página");
            });
        }
        else{
          
          if(data.target.indexOf("null") !== -1)
          {
            alert("error al actualizar la actividad, por favor refrescar la página");
            return false;
          }
          axios
            .put(
              `${API_ROUTE}v2/schedule-tasks-move/${gantt.serverList("projectId")[0]}`,
              data,
              headersRequest()
            )
            .then(() => {
              gantt.refreshData();
              })
            .catch((err) => {
              alert("error al actualizar la actividad, por favor refrescar la página");
            });

        }
        
        break;
      case "delete":
        axios
          .delete(`${API_ROUTE}v2/schedule-tasks/${data.id}`, headersRequest())
          .then(() => {
            gantt.refreshData();
           
            })
          .catch((err) => {
            alert("error al eliminar la actividad, por favor refrescar la página");
          });
        break;
    }
  }
  else if(entity === "link")
  {
    switch(action)
    {
      case "create":
        if (data.id > 1000000) {
          axios
            .post(
              `${API_ROUTE}schedule-tasks-dependencies/${gantt.serverList("projectId")[0]}`,
              {predecessorId:data.source, successorId: data.target},
              headersRequest()
            )
            .then(() => {
              gantt.refreshData();
              })
            .catch((err) => {
              alert("error al crear la relación, por favor refresca la página");
            });
        }
        break;
      case "delete":
        axios
        .delete(
          `${API_ROUTE}schedule-tasks-dependencies/${data.source}/${data.target}/${gantt.serverList("projectId")[0]}`,
          headersRequest()
        )
        .then(() => {
          gantt.refreshData();
          })
        .catch((err) => {
          alert("error al eliminar la relación, por favor refresca la página");
        });            
      break;
    }
  }
}); */ 
 
useEffect(()=>{
var dp = gantt.createDataProcessor({
    task:{
    create: (data)=>{
      let start = moment(data.start_date, "DD-MM-YYYY HH:mm");
      let end = moment(data.end_date, "DD-MM-YYYY HH:mm");
      if (start > end) {
        return;
      }
      data.projectUID = gantt.serverList("projectId")[0];
      data.key = data.id;
      data.parentId = data.parent;
      data.start = start.format();
      data.end = end.format();
      data.start_date = start.format();
      data.end_date = end.format();
     
      axios
      .post(
        `${API_ROUTE}v2/schedule-tasks`,
        data,
        headersRequest()
      )
      .then(function (response) {
        console.log("se creo tarea")
        gantt.changeTaskId(data.id, response.data.TaskUID);
        gantt.refreshData()
        
    
      })
      .catch((err) => {
        console.log("error")
        /* alert("error al crear la actividad, por favor refrescar la página"); */
      });
           
    }
  }
 })

},[])
  return (
    <>
    {/* <div class="btn-group-sm">
          <button className='btn btn-success btn-xs mr-2 ml-2' onClick={zoomIn}><i className='fa fa-plus'></i></button>
          <button className='btn btn-success mr-2 ml-2' onClick={zoomOut}><i className='fa fa-minus'></i></button>
          <button className='btn btn-success mr-2 ml-2' onClick={(e)=>updateCriticalPath(e)}>+ Ruta crítica</button>
    </div>  */}
    <div id='show-btns-gantt' className='bg-light'>
     {/*  <input type='text' id='datepicker'/> */}
    <Container fluid className='bg-light'>
    <Row>
        <Col className="pt-3 pb-2">
          <div className="d-flex align-items-center">
            
            <div className="group-btns-gantt">
            
            <Button
              className="mr-2"
              variant="outline-dark"
              size="sm"
              onClick={btnUndo}
              title ="Deshacer"
            >
                <i className="fa fa-undo"></i>
            </Button>
            <Button
              className="mr-2"
              variant="outline-dark"
              size="sm"
              onClick={btnRedo}
              title="Rehacer"
            >
                <i className="fa fa-redo"></i>
            </Button>
            <Button
              className="mr-2"
              variant="outline-dark"
              size="sm"
              onClick={collapseAllTask}
              title ="Agrupar"
            >
                <i className="fa fa-angle-double-up"></i>
            </Button>
            <Button
              className="mr-2"
              variant="outline-dark"
              size="sm"
              onClick={expandAllTask}
              title='Expandir'
            >
                <i className="fa fa-angle-double-down"></i>
            </Button>
            <Button
              className="mr-2"
              variant="outline-dark"
              size="sm"
              onClick={(e)=>updateCriticalPath(e)}
            >
               Mostrar Ruta crítica 
            </Button>
            <Button
              className="btn-gantt-reca"
              variant="outline-dark"
              size="sm"
              onClick={zoomIn}
            >
              Zoom <i className="fa fa-plus"></i>
            </Button>
            <Button
              variant="outline-dark"
              size="sm"
              onClick={zoomOut}
              className="mx-2 btn-gantt-resour"
            >
              Zoom <i className="fa fa-minus"></i>
            </Button>
           {/*  <Button
              className="mr-2 btn-gantt-gest"
              variant="outline-dark"
              size="sm"
            
            > 
            
              Gestión Documental
            </Button> */}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
    <div id="gantt-dxhtml" className='gantt_box_dxhtml' ></div> 
    </div>
    </>
  )
}

export default GanttDx